import { fetchPlamaApi } from "../clients/PlamaClient.js";

//GET
export const getGroupStatements = async (groupId, authenticationToken) => {
    return await fetchPlamaApi('statement/group/' + groupId, authenticationToken, [], 'GET')
};